// extracted by mini-css-extract-plugin
export default {"treeImagesBox":"page-leafcomplete_treeImagesBox__zvBH8","treeImage":"page-leafcomplete_treeImage__QAG-h","arrow":"page-leafcomplete_arrow__Wr10S"};